module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-down-left-3.97fe1b99.png";